/**
 * Single source of truth for public routes.
 * `AppRoutes` renders these lazily in the browser; the prerender entry awaits
 * the same loaders so every route can be rendered to static HTML at build time.
 */
export const ROUTE_DEFINITIONS = [
  { path: '/', load: () => import('../pages/Home') },
  { path: '/corporate', load: () => import('../pages/CorporatePage') },
  { path: '/workshops', load: () => import('../pages/WorkshopsPage') },
  { path: '/workshops/japanese-kintsugi', load: () => import('../pages/KintsugiPage') },
  { path: '/events', load: () => import('../pages/EventsPage') },
  { path: '/calendar', load: () => import('../pages/CalendarPage') },
  { path: '/gallery', load: () => import('../pages/GalleryPage') },
  { path: '/about', load: () => import('../pages/AboutPage') },
  { path: '/contact', load: () => import('../pages/ContactPage') },
  { path: '/privacy-policy', load: () => import('../pages/PrivacyPolicyPage') },
  { path: '/terms', load: () => import('../pages/TermsPage') },
  { path: '/cancellation-refund', load: () => import('../pages/CancellationRefundPage') },
];
